module.exports = __webpack_public_path__ + "img/1482135778502.472300f2.jpg";